export default {
  labels: {
    signed_by: 'Podpisano przez {{name}} dnia {{date}}',
    signed_by_no_date: 'Podpisano przez {{name}}',
  },
  buttons: {
    retry: 'Spróbuj ponownie',
  },
  errors: {
    load_failed: 'Nie udało się wczytać umowy. Sprawdź połączenie i spróbuj ponownie.',
  },
};
